import { axios } from '@/utils/request'

const api = {
  RoleList: '/admin.php/Admin/getRoleList',
  RoleDetail: '/admin.php/Admin/roleDetail',
  AddRole: '/admin.php/Admin/addRole',
  UpdateRole: '/admin.php/Admin/updateRole',
  GetAuthData: '/admin.php/Admin/getAuthData',
  SaveRoleAuth: '/admin.php/Admin/saveRoleAuth',
  DelRole: '/admin.php/Admin/delRole'
}

export function getRoleList (parameter) {
  return axios({
    url: api.RoleList,
    method: 'get',
    params: parameter
  })
}

export function getRoleDetail (parameter) {
  return axios({
    url: api.RoleDetail,
    method: 'get',
    params: {
      role_id: parameter
    }
  })
}

export function postRoleBasicInfo (parameter) {
  return axios({
    url: api.AddRole,
    method: 'post',
    data: parameter
  })
}

export function postUpdateRole (parameter) {
  return axios({
    url: api.UpdateRole,
    method: 'post',
    data: parameter
  })
}

export function postDeleteRole (params) {
  return axios({
    url: api.DelRole,
    method: 'post',
    data: {
      role_id: params
    }
  })
}

export function getAuthData () {
  return axios({
    url: api.GetAuthData,
    method: 'get'
  })
}

export function postAddRolePermission (parameter) {
  return axios({
    url: api.SaveRoleAuth,
    method: 'post',
    data: parameter
  })
}
